
import {IElement, ITextAttributes, ITextPartAttributes} from 'routes/private/Editor/types';
import { updateRenderingTextSegments } from 'utils/textMultiStyling'

export const textResolver = ( element: IElement, value: any ) => {
    if (element.type === "Text") {
        if (typeof value==="string") {
            (element.attributes as ITextAttributes).text = value;
            let part: ITextPartAttributes = {...(element.attributes as ITextAttributes).parts[0], length: value.length};
            (element.attributes as ITextAttributes).parts = [{...part}];
            element.attributes = updateRenderingTextSegments(element.attributes);
        }
        else {
            element.attributes = updateRenderingTextSegments(value);
        }
    }
    return element;
}